import React from 'react';

import { Input } from 'baseui/input';
import dayjs from 'dayjs';
import _get from 'lodash/get';
import _toUpper from 'lodash/toUpper';
import _toLower from 'lodash/toLower';
import _isFunction from 'lodash/isFunction';

import { CASE } from '../../../../constants';

interface ITextProps {
	inputType?: string;
	value?: any;
	onChange?: any;
	type?: any;
	letterCase?: CASE;
	min?: number;
	onChangeCallback?: any;
	disabled?: boolean;
}

const Text: React.FC<ITextProps> = (props) => {
	const { inputType = '', value, onChange, letterCase = CASE.NOCASE, onChangeCallback, disabled } = props;

	const handleOnChange = (event: React.FormEvent<HTMLInputElement>) => {
		const inputValue = _get(event, ['target', 'value']);
		if (inputType === 'datetime-local') {
			const timeInEpoch = inputValue && dayjs(inputValue, 'YYYY-MM-DDTHH:mm').valueOf();
			onChange(timeInEpoch);
		} else if (inputType === 'date') {
			const timeInEpoch = inputValue && dayjs(inputValue, 'YYYY-MM-DD').valueOf();
			onChange(timeInEpoch);
		} else if (letterCase === CASE.UPPERCASE) {
			onChange(_toUpper(inputValue));
		} else if (letterCase === CASE.LOWERCASE) {
			onChange(_toLower(inputValue));
		} else {
			onChange(inputValue);
		}
		if (_isFunction(onChangeCallback)) {
			onChangeCallback(props);
		}
	};

	const getValue = () => {
		if (inputType === 'datetime-local') {
			return dayjs(value).format('YYYY-MM-DDTHH:mm');
		}
		if (inputType === 'date') {
			return dayjs(value).format('YYYY-MM-DD');
		}
		return value;
	};

	return <Input {...props} onChange={handleOnChange} disabled={disabled} value={getValue()} />;
};

export default Text;
